import { useCallback, useMemo } from "react";
import "./Button.css";

const handleCopy = () => {
  const contract = "Dby4bVRzM3pHpoLWRzWLyWu2mGk3vtnzLTCjDfctpump";
  navigator.clipboard.writeText(contract);
};

export const Button = ({ data }) => {
  const clickToLink = useCallback(() => {
    if (data.link) {
      window.open(data.link, "_blank");
    }
  }, [data.link]);

  const style = useMemo(() => {
    return {
      width: data.width,
      height: data.height,
      fontSize: data["font-size"], // Используем camelCase для fontSize
    };
  }, [data]);

  return (
    <div
      style={style}
      className="button"
      onClick={data.isCopy ? handleCopy : clickToLink}
    >
      {data.img ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <img src={data.img} alt={data.text} draggable={false} />
          {data.text}
        </div>
      ) : (
        data.text
      )}
    </div>
  );
};
